import React from "react";
import { Layout, Menu, Typography } from "antd";
import styles from "./tabs.module.less";
import { Container } from "./containers";
import { usePlansContext } from "../../context/PlansContext";
import { useTranslation } from "react-i18next";
import { updateTabIndex } from "../../actions/plansActions";
import { primeColor } from "../theme.js";

const { Header, Content } = Layout;
const { Title } = Typography;

const TabLayout = props => {
    const { children } = props;
    const { dispatch } = usePlansContext();
    const { t } = useTranslation();
    const tabTitle = title => <div style={{ fontSize: "1rem", fontWeight: "500" }}>{title}</div>;
    return (
        <Layout
            style={{
                position: "relative",
                margin: "0 auto",
            }}
        >
            <Header style={{ height: "100%", background: primeColor, padding: 0 }}>
                <Container>
                    <Title level={2} className={styles.heading} style={{ marginBottom: 0 }}>
                        {t("Select Your Plan")}
                    </Title>
                    <div className={styles.subHeading}>
                        {`Try MailChannels risk-free. 30-day money-back guarantee. Cancel anytime.`}
                    </div>
                </Container>
                <Container
                    style={{
                        minHeight: "400px",
                        maxWidth: "960px",
                        background: "#fff",
                    }}
                >
                    <div
                        className={styles.menuSelector}
                        style={{ maxWidth: "750px", margin: "0 auto" }}
                    >
                        <Menu
                            onClick={e => dispatch(updateTabIndex(e.key))}
                            mode="horizontal"
                            defaultSelectedKeys={["2"]}
                            style={{ lineHeight: "2rem", textAlign: "center" }}
                        >
                            <Menu.Item key="0">
                                <div className={styles.menuItem}>{tabTitle(t("Inbound"))}</div>
                            </Menu.Item>
                            <Menu.Item key="1">
                                <div className={styles.menuItem}>{tabTitle(t("Outbound"))}</div>
                            </Menu.Item>
                            <Menu.Item key="2">
                                <div className={styles.menuItem}>
                                    {tabTitle(t("Inbound + Outbound"))}
                                </div>
                            </Menu.Item>
                        </Menu>
                    </div>
                </Container>
            </Header>
            <Content
                style={{
                    width: "100%",
                    minHeight: "400px",
                    background: "#fff",
                    margin: "0 auto",
                }}
            >
                {children}
            </Content>
        </Layout>
    );
};

export default TabLayout;
